"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TABLE_FILTER_FIELD_WIDTH = exports.TABLE_FILTER_DATE_WIDTH = void 0;
exports.TableFilterReset = TableFilterReset;
exports.TableFilterSelect = TableFilterSelect;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("@iconify/react");
var TABLE_FILTER_FIELD_WIDTH = "w-[200px]";
exports.TABLE_FILTER_FIELD_WIDTH = TABLE_FILTER_FIELD_WIDTH;
var TABLE_FILTER_DATE_WIDTH = "w-[260px]";
exports.TABLE_FILTER_DATE_WIDTH = TABLE_FILTER_DATE_WIDTH;
function TableFilterSelect(_a) {
    var _b, _c, _d;
    var aria_label = _a.aria_label, icon = _a.icon, options = _a.options, value = _a.value, on_change = _a.on_change;
    var selectedLabel = (_c = (_b = options.find(function (option) { return option.key === value; })) === null || _b === void 0 ? void 0 : _b.label) !== null && _c !== void 0 ? _c : (_d = options[0]) === null || _d === void 0 ? void 0 : _d.label;
    var handleSelectionChange = function (keys) {
        if (!(keys instanceof Set))
            return;
        var key = Array.from(keys)[0];
        if (key !== undefined)
            on_change(String(key));
    };
    return ((0, jsx_runtime_1.jsxs)(react_1.Dropdown, { children: [(0, jsx_runtime_1.jsxs)(react_1.Button, { variant: "secondary", children: [(0, jsx_runtime_1.jsx)(react_2.Icon, { icon: icon, width: 20 }), selectedLabel, (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "mdi:chevron-down", width: 20 })] }), (0, jsx_runtime_1.jsx)(react_1.Dropdown.Popover, { children: (0, jsx_runtime_1.jsx)(react_1.Dropdown.Menu, { "aria-label": aria_label, selectionMode: "single", disallowEmptySelection: true, selectedKeys: [value], onSelectionChange: handleSelectionChange, children: options.map(function (option) { return ((0, jsx_runtime_1.jsxs)(react_1.Dropdown.Item, { id: option.key, textValue: option.label, children: [(0, jsx_runtime_1.jsx)(react_1.Dropdown.ItemIndicator, {}), (0, jsx_runtime_1.jsx)(react_1.Label, { children: option.label })] }, option.key)); }) }) })] }));
}
function TableFilterReset(_a) {
    var is_disabled = _a.is_disabled, on_press = _a.on_press;
    return ((0, jsx_runtime_1.jsxs)(react_1.Button, { variant: "primary", isDisabled: is_disabled, onPress: on_press, children: [(0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "mdi:filter-variant-remove", width: 20 }), "Reset"] }));
}
